import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { Flex, Heading, Text, Image } from 'rebass/styled-components'

const RealTimeCard = ({ type, src, ...props }) => {
  const { t } = useTranslation('home')

  return (
    <Flex
      flexDirection="column"
      alignItems={['center', 'center', 'flex-start']}
      height={['auto', 'auto', '620px']}
      maxWidth={['360px', '520px', '570px']}
      pt={[5, 20]}
      px={[5, 10]}
      pb={[5, 10]}
      bg="white"
      textAlign={['center', 'center', 'left']}
      sx={{
        transition: 'all .125s ease-in-out',
        cursor: 'pointer',

        '@media (min-width: 32rem)': {
          boxShadow: '0px 30px 80px rgba(33, 47, 64, 0.1)',
          borderRadius: '10px',
          ':hover': {
            transform: 'translateY(-20px)'
          }
        }
      }}
      {...props}
    >
      <Image width={['100px', '60%']} maxHeight="305px" mx="auto" mb={[8, 14, 22]} src={src} />

      <Heading mb={5} variant="level3" fontWeight="500">
        {t(`real_time.${type}.title`)}
      </Heading>

      <Text variant="level6">{t(`real_time.${type}.description`)}</Text>
    </Flex>
  )
}
RealTimeCard.propTypes = {
  type: PropTypes.string,
  src: PropTypes.string
}

export default RealTimeCard
